
import {Component, Mixins, Ref} from 'vue-property-decorator'
import {mapActions, mapGetters} from "vuex";
import {uGetDateFormat} from '@appbase/util';
import api from '@webparts/api/graph';
import * as accountTypes from '@account/store/types';
import * as msTeams from "@microsoft/teams-js";
import accountApi from '@account/api';
import UserCardComponent from '@appbase/components/common/UserCard/UserCardComponent';

@Component({
    computed: {
        ...mapGetters({
            current: accountTypes.CURRENT
        })
    },
    methods: {
        ...mapActions({
            forceToGetAccessToken: accountTypes.MS_ACCESSTOKEN_FORCE,
        })
    }
})
export default class FileList extends UserCardComponent {
    current!: account.TCurrent;

    forceToGetAccessToken!: () => Promise<string>;

    @Ref('refDivScroll') scrollDiv!: HTMLElement;

    fileImages: { [key: string]: any } = {
        'xls': require('@webparts/assets/file_excel.png'),
        'xlsx': require('@webparts/assets/file_excel.png'),
        'ppt': require('@webparts/assets/file_ppt.png'),
        'pptx': require('@webparts/assets/file_ppt.png'),
        'docx': require('@webparts/assets/file_word.png'),
        'doc': require('@webparts/assets/file_word.png'),
        'none': require('@webparts/assets/file_nonoffice.png')
    }

    recentFiles: graph.DriveItem[] = [];
    currentPage: number = 0;
    filesPerPage: number = 20;
    onLoadMore: boolean = false;
    reachingEnd: boolean = false;

    mFiles: graph.DriveItem[] = [];
    mFileParentInfos: graph.DriveItem[] = [];

    isNotSupportAuthType: boolean = false;

    getParentPath(parentId: string) {
        let parentInfo = this.mFileParentInfos.find(pi => pi.id === parentId);
        let rootPath = parentInfo?.parentReference.name ?? ''
        let foldername = parentInfo?.name ?? ''

        if (foldername === 'root') {
            return this.$t('내_문서').toString()
        } else if (foldername.length > 0) {
            return `${rootPath} > ${foldername}`;
        } else {
            return '';
        }
    }

    fileImage(fileName: string) {
        let extension = fileName.split('.').pop() ?? '';
        extension = Object.keys(this.fileImages).findIndex(i => i === extension.toLowerCase()) >= 0 ?
            extension.toLowerCase() : 'none';

        return this.fileImages[extension];
    }

    modifiedDisplayTime(modified: string) {
        return uGetDateFormat('yyyy-MM-dd H:i:s', new Date(modified));
    }

    loadMore() {
        if (!(this.onLoadMore || this.reachingEnd)) {
            this.onLoadMore = true;
            setTimeout(() => {
                this.currentPage += 1;
                let append = this.getPage(this.currentPage);
                this.mFiles = [
                    ...this.mFiles,
                    ...append
                ]

                this.loadFilePath(append);
                this.onLoadMore = false;
            }, 1000);
        }
    }

    loadFilePath(items: graph.DriveItem[]): Promise<graph.DriveItem[]> {
        var infoRequest: graph.DriveItemsRequet = {
            items: items.map(f => <graph.DriveItemRequest>{
                driveId: f.parentReference.driveId,
                itemId: f.parentReference.id
            })
        }

        return api.getDriveItems(infoRequest).then(res => {
            this.mFileParentInfos = [
                ...this.mFileParentInfos,
                ...res
            ]
            return res;
        });
    }

    getPage(page: number): graph.DriveItem[] {
        let startIdx = (page - 1) * this.filesPerPage;
        let endIdx = page * this.filesPerPage;

        if (endIdx >= (this.recentFiles.length - 1)) {
            this.reachingEnd = true;
        }

        return this.recentFiles.slice(startIdx, endIdx);
    }

    onOpenFile(file: graph.DriveItem) {
        window.open(file.webUrl);
    }

    onScroll(e: any) {
        if (this.scrollDiv) {
            if (this.scrollDiv.offsetHeight + this.scrollDiv.scrollTop >= this.scrollDiv.scrollHeight) {
                this.loadMore();
            }
        }
    }

    async handleGetDataError(err: any){
        try{
            let res = await accountApi.auth.getLogonType();
            if(res){
                let logonType = res.toLocaleLowerCase();
                let accessTokenExceptions = ["AccessTokenExpiredException", "AccessTokenNullException"];
                let token;

                if(err?.type == accessTokenExceptions[1]){
                    throw new Error('Access token is null');
                }

                if(this.isTeams){
                    try{
                        token = await msTeams.authentication.getAuthToken();
                        if(token == null || token === ''){
                            throw new Error('Failed to retrieve access token');
                        }
                    }
                    catch(error) {
                        console.error('Error getting Teams auth token:', error);
                        this.recentFiles = [];
                    }

                }
                // 인사 계정인 경우
                else if(logonType == 'entraid' && this.current.user.isHRData){
                    try{
                        token = await this.forceToGetAccessToken();
                        if(token == null || token === ''){
                            throw new Error('Failed to retrieve access token');
                        }

                    }
                    catch(error){
                        console.error('Error getting access token:', error);
                        this.recentFiles = [];
                    }
                }
                else {
                    console.error(err);
                    this.isNotSupportAuthType = true;
                    this.recentFiles = [];
                }

                if(token != null && token !== ''){
                    accountApi.auth.setAccessTokenByIdToken(token).then((res) => {
                        if(res){
                            this.getData();
                        }
                        else{
                            throw new Error('Failed to set access token');
                        }
                    }).catch((error) => {
                        throw error;
                    })
                }
            }
        }
        catch(error){
            console.error(error);
            this.recentFiles = [];
        }
    }

    async getData(){
        try{
            let res = await api.getRecentFiles();
            if(res){
                this.recentFiles = res.sort((a, b) => {
                    let aTime = (new Date(a.lastModifiedDateTime)).getTime();
                    let bTime = (new Date(b.lastModifiedDateTime)).getTime();
                    return bTime - aTime;
                });

                let pageItems = this.getPage(1);
                this.mFiles = pageItems;
                this.currentPage = 1;
                this.$emit('mounted');
                this.loadFilePath(pageItems);
            }
        }
        catch(e){
            throw e;
        }
    }

    async init(){
        try{
            await this.getData();
        }
        catch(err: any){
            await this.handleGetDataError(err);
            this.$emit('mounted');
        }
    }

    async mountAction() {
        this.init();
    }

    created() {
        this.mountAction();
    }
}